// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1zQQS","right":"styles_right__3s4VH"};